export function installRequest(state = {
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_INSTALL_START":           
        case "UPDATE_INSTALL_START":           
        case "RECEIVE_INSTALL_START":           
        case "DELETE_INSTALL_START":           
        case "FETCH_INIT_DATA2_START":           
            return {
                ...state, 
                fetching:true
            }        
        case "CREATE_INSTALL_FULFILLED":           
        case "UPDATE_INSTALL_FULFILLED":           
        case "RECEIVE_INSTALL_FULFILLED":           
        case "DELETE_INSTALL_FULFILLED":           
        case "FETCH_INIT_DATA2_FULFILLED":           
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_INSTALL_ERROR":
        case "UPDATE_INSTALL_ERROR":
        case "RECEIVE_INSTALL_ERROR":
        case "DELETE_INSTALL_ERROR":
        case "FETCH_INIT_DATA2_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}